"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkCard = exports.Card = void 0;

var _Card = require("./Card");

var Card = (0, _Card.createCardComponent)({
  name: 'Card',
  tag: 'div',
  interactive: false
});
exports.Card = Card;
var LinkCard = (0, _Card.createCardComponent)({
  name: 'LinkCard',
  tag: 'a',
  interactive: true,
  // Remove styles inherited from <a>
  additionalStyles: "\n    color: unset;\n    text-decoration: unset;\n  "
});
exports.LinkCard = LinkCard;